import React from "react";
import Slider from "react-slick";
import Button from "../components/btn"
import styled from "styled-components"
import "../assets/stylesheets/components/hero.scss"
import microsoftLogo from "../assets/images/logo-ms.svg"
import esetHeroImage from "../assets/images/hero/hero-eset-cybersecurity-pro.png"

import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';

const SliderContainer = styled.div`
  color: white;
  height: 50vh;
  margin-bottom: 5rem;
`
// clip-path: polygon(0 0, 100% 0, 100% 85%, 0% 100%);
let SlickSlider = () => {
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
  };

  return (
    <SliderContainer className="hero__slider">
      <Slider {...settings}>
        <div>
          <div className="hero__container">
            <div className="hero__box bg-grey px-5">
              <img className="img__ms-logo" src={microsoftLogo} alt="" height="40px"/>
              <p className="h2 font-weight-bold">Office 365.</p><p className="h3 mb-4">Scegli gli strumenti di cui hai bisogno oggi per te o per la tua azienda.</p>
              <Button to="/office365" className="btn btn-primary btn-lg">
                Scopri Office365
              </Button>
            </div>
            <div className="hero__box hero__banner1"></div>
          </div>
        </div>
        <div>
        <div className="hero__container">
            <div className="hero__box" style={{backgroundColor: '#0096a1'}}>
              <p className="h2 font-weight-bold text-white mb-3">ESET CYBER SECURITY PRO</p>
              <p className="h4 text-white col-lg-6 pl-0 mb-3">Proteggi tutti gli aspetti della tua vita digitale con funzionalità all'avanguardia e machine learning avanzato. Protegge i dispositivi Windows, Mac, Android e Linux.</p>
              <Button to="https://www.eset.com/it/privati/versione-prova-gratuita/" className="btn btn-primary btn-lg">
                Prova gratuita 30 giorni
              </Button>
              <img className="eset-image d-none d-xl-block" src={esetHeroImage} alt=""/>
            </div>
          </div>
        </div>
        {/* <div>
          <div className="text-center">
            <h1>{title}</h1>
            <p>By {author}</p>
          </div>
        </div> */}
      </Slider>
    </SliderContainer>
  )
}

export default SlickSlider
